import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as actionTypes from "../../../constants/actionTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as windowService from "../../../services/windowService";
import * as modelHelper from "../../../helpers/modelHelper";

import imgOk from "../../../resources/img/svgicons/confirm.svg";

import Button from "../generic/Button";
import Modal from "../generic/Modal";
import CancelButton from "../generic/CancelButton";

class ConfirmationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ignoreConfirmation: false
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleIgnoreConfirmationCheckBoxCahnge = () => {
        this.setState({
            ignoreConfirmation: !this.state.ignoreConfirmation
        });
    };

    handleConfirmClick = () => {
        if (this.state.ignoreConfirmation) {
            if (this.props.params.next && windowService.addIgnoredConfirmation(this.props.params.next.type)) {
                this.props.dispatchAction(this.props.params.next);
                this.props.dispatchCloseModalAction();
            }
        } else {
            this.props.dispatchAction(this.props.params.next);
            this.props.dispatchCloseModalAction();
        }
    };

    getModalMessage = () => {
        if (this.props.params.dialog !== null) {
            if (this.props.params.next === null || this.props.params.hideMessageSuffix) {
                return this.props.params.dialog;
            }

            return this.props.params.dialog + " " + translate("help.continue");
        }

        return translate("general.confirmDeletion");
    };

    getDoNotShowAgainCheckbox = () => {
        if (this.props.params.next && this.props.params.next.type === actionTypes.NAVIGATION_CLOSE_REDLIKE_WINDOW) {
            return (
                <div className="col-12 margin-top-15">
                    <input
                        type="checkbox"
                        id="doNotShowAgain"
                        name="doNotShowAgain"
                        checked={this.state.ignoreConfirmation}
                        onChange={this.handleIgnoreConfirmationCheckBoxCahnge}
                    />
                    <label htmlFor="doNotShowAgain" className="font-normal margin-left-10">
                        {translate("general.doNotShowAgain")}
                    </label>
                </div>
            );
        }

        return "";
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.warning" />)}
                content={modelHelper.buildModalSection(
                    <React.Fragment>
                        <div className="col-12 font-size-1_5em">{this.getModalMessage()}</div>
                        <div className="col-12">{this.getDoNotShowAgainCheckbox()}</div>
                    </React.Fragment>,
                    "flex-column"
                )}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        <CancelButton onClick={this.handleCloseModalClick} />
                        {this.props.params.next && (
                            <Button
                                onClick={this.handleConfirmClick}
                                svgBefore={
                                    this.props.params.confirmBtn !== null && !this.props.params.showCustomConfirmBtnIcon
                                        ? null
                                        : imgOk
                                }
                                label={this.props.params.confirmBtn ?? translate("general.confirm")}
                            />
                        )}
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CONFIRMATION_MODAL));
        },
        dispatchAction: (action) => {
            dispatch(action);
        }
    };
};

export default ConfirmationModal = connect(mapStoreToProps, mapDispatchToProps)(ConfirmationModal);
